import { PERMISSIONS } from '@conversed/shared/src/central/constants/permissions';
import { z } from 'zod';
import { createRESTContract } from '../../index';
import {
  TemplateResponseFormSchema,
  TemplateResponseSchema,
} from './template-response.schema';

export const templateResponseContract = createRESTContract({
  getTemplateResponses: {
    method: 'GET',
    path: '/template-responses',
    permissions: [PERMISSIONS.TEMPLATE_RESPONSE.TEMPLATE_RESPONSE_LIST],
    response: TemplateResponseSchema.array(),
  },
  createTemplateResponse: {
    method: 'POST',
    path: '/template-response',
    permissions: [PERMISSIONS.TEMPLATE_RESPONSE.TEMPLATE_RESPONSE_CREATE],
    body: TemplateResponseFormSchema,
    response: TemplateResponseSchema.array(),
  },
  updateTemplateResponse: {
    method: 'PUT',
    path: '/template-response/:id',
    permissions: [PERMISSIONS.TEMPLATE_RESPONSE.TEMPLATE_RESPONSE_EDIT],
    body: TemplateResponseFormSchema,
    response: TemplateResponseSchema.array(),
  },
  deleteTemplateResponse: {
    method: 'DELETE',
    path: '/template-response/:id',
    permissions: [PERMISSIONS.TEMPLATE_RESPONSE.TEMPLATE_RESPONSE_DELETE],
    body: z.undefined(),
    response: z.void(),
  },
});
